import { render } from "./AttrTree.vue?vue&type=template&id=27b8b0c6"
import script from "./AttrTree.vue?vue&type=script&lang=js"
export * from "./AttrTree.vue?vue&type=script&lang=js"

import "./AttrTree.vue?vue&type=style&index=0&id=27b8b0c6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27b8b0c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27b8b0c6', __exports__)) {
    api.reload('27b8b0c6', __exports__)
  }
  
  module.hot.accept("./AttrTree.vue?vue&type=template&id=27b8b0c6", () => {
    api.rerender('27b8b0c6', render)
  })

}


export default __exports__